/* eslint-disable */
import axios from '@/assets/js/axiosExtend.js'
import { Message } from 'element-ui'
import i18n from '@/lang'

const messageTip = {
  removeParticipant: 'authorizeOperation.removeS',
  startPrivateConversation: 'partylineGuest.createPrivateConversation',
  cancelPrivateConversation: 'partylineGuest.privateConversationHung',
  setCrew: 'authorizeOperation.success',
  cancelCrew: 'authorizeOperation.removeS'
}
const errorTip = {
  cancelCew: 'addWords.stopCrewFailed',
  82201102: 'addWords.commonPartyLimits'
}
const fn = function(params, tips = true) {
  return new Promise((resolve, reject)=>{
    axios.post('/partyline-backend/party/noLogin/command?key=56692', params).then(res => {
      if (res.data.errorCode === '0x0') {
        if (tips && messageTip[params.module]) {
          Message({
            type: 'success',
            message: i18n.t(messageTip[params.module]),
            offset: 50,
            showClose: true
          })
        }
      } else {
        if (errorTip[params.module] || errorTip[res.data.errorCode]) {
          Message({
            type: 'error',
            message: i18n.t(errorTip[params.module]),
            offset: 50,
            showClose: true
          })
        }
      }
      resolve(res.data)
    }).catch((error)=>{
      reject(error)
    })
  })
}

export default {
  fn
};